import { useState, useRef } from 'react';
import api from '../api';

const apiUrl = process.env.REACT_APP_API_BASE_74;

const PAGE_SIZE = 200;

const useBuscaEstabelecimentoGlobal = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pagina, setPagina] = useState(0);
  const [temMais, setTemMais] = useState(true);
  const filtrosRef = useRef({});

  const buildQueryString = (params) => {
    return Object.entries(params)
      .filter(([_, v]) => v !== undefined && v !== null && v !== '')
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
      .join('&');
  };

  const loadregistros = async (reset = false, filtros = {}) => {
    setLoading(true);
    setError(null);
    try {
      if (reset) {
        setPagina(0);
        setTemMais(true);
        filtrosRef.current = filtros;
      }
      const skip = reset ? 0 : pagina * PAGE_SIZE;
      const query = buildQueryString({ ...filtrosRef.current, skip, limit: PAGE_SIZE });
      const response = await api.get(`${apiUrl}?${query}`);
      const novos = Array.isArray(response.data) ? response.data : (response.data.cadastros || []);
      setSearchResults(prev => reset ? novos : [...prev, ...novos]);
      setTemMais(novos.length === PAGE_SIZE);
      setPagina(prev => reset ? 1 : prev + 1);
    } catch (error) {
      setError('Erro ao buscar cadastros globais. Veja o console para mais detalhes.');
      if (reset) setSearchResults([]);
    } finally {
      setLoading(false);
    }
  };

  const resetBusca = (filtros = {}) => {
    setPagina(0);
    setTemMais(true);
    loadregistros(true, filtros);
  };

  return { searchResults, loadregistros, loading, error, temMais, resetBusca };
};

export default useBuscaEstabelecimentoGlobal; 